<template>
  <div class="seal-view" v-show="src">
    <img :src="src" />
  </div>
</template>

<script>
const baseURL = process.env.VUE_APP_API_URL || process.env.BASE_URL || "";

export default {
  props: {
    bizType: String,
    url: String,
  },
  data() {
    return {
      src: null,
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      const me = this;
      if (me.url) {
        me.src = me.parseUrl(me.url);
      } else if (me.bizType) {
        me.$ajax({
          url: "/api/commons/sealsetting/get_by_type",
          params: {
            bizType: me.bizType,
          },
        }).then(function (res) {
          if (res.success) {
            me.src = me.parseUrl(res.data);
          }
        });
      }
    },
    parseUrl(url) {
      if (url && url != "/BLANK.png") {
        if (!/(http|ftp|https):\/\//.test(url)) {
          url = baseURL + "/api/file/download?path=" + url;
        }
      }
      return url;
    },
  },
};
</script>

<style scoped>
.seal-view {
  position: absolute;
  top: 30px;
  left: 100px;
  width: 115px;
  height: 115px;
}

.seal-view img {
  width: 100%;
  height: 100%;
}
</style>